import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "displayTemplate", "editTemplate"]
  static values = { confirmMessage: String }

  add(event) {
    event.preventDefault()
    const entry = this.cloneTemplate(this.editTemplateTarget)
    this.listTarget.appendChild(entry)
    entry.querySelector("input[type=text]").focus()
  }

  edit(event) {
    event.preventDefault()
    const oldEntry = event.currentTarget.closest("[data-substitutes-entry]")
    const value = oldEntry.querySelector("input[type=hidden]").value
    const entry = this.cloneTemplate(this.editTemplateTarget)
    const input = entry.querySelector("input[type=text]")
    entry.querySelector("input[type=hidden]").value = value
    input.value = value
    oldEntry.replaceWith(entry)
    input.focus()
    input.select()
  }

  commit(event) {
    const value = event.target.value.trim()
    const oldEntry = event.target.closest("[data-substitutes-entry]")

    if (!value) {
      oldEntry.remove()
      this.save()
      return
    }

    const entry = this.cloneTemplate(this.displayTemplateTarget)
    entry.querySelector("input[type=hidden]").value = value
    entry.querySelector("[data-substitutes-label]").textContent = value
    oldEntry.replaceWith(entry)
    this.save()
  }

  onKeydown(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      event.target.blur()
    }
    if (event.key === "Escape") {
      event.preventDefault()
      const entry = event.target.closest("[data-substitutes-entry]")
      const hidden = entry.querySelector("input[type=hidden]")
      if (hidden.value) {
        const display = this.cloneTemplate(this.displayTemplateTarget)
        display.querySelector("input[type=hidden]").value = hidden.value
        display.querySelector("[data-substitutes-label]").textContent = hidden.value
        entry.replaceWith(display)
      } else {
        entry.remove()
      }
    }
  }

  confirmRemove(event) {
    event.preventDefault()
    if (!confirm(this.confirmMessageValue)) return

    event.currentTarget.closest("[data-substitutes-entry]").remove()
    this.save()
  }

  save() {
    const form = this.element.closest("form")
    if (!form) return

    fetch(form.action, {
      method: "POST",
      body: new FormData(form),
      headers: {
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
      }
    })
  }

  cloneTemplate(template) {
    return template.content.firstElementChild.cloneNode(true)
  }
}
